<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title  class="modal-title">{{ 'Share.Share'| translate }}</ion-title>
  </ion-toolbar>
</ion-header>
@if (item) {
  <ion-content class="content" (click)="trackClick($event)">
    <form #share>
      <ion-grid>
        <ion-row style="margin-top: 30px; font-weight: bold;">
          <ion-col style="display: flex; justify-content: center;">
            <ion-label style="text-align: center;">
              <p style="font-weight: bold; color: var(--color); font-size: 16px;">{{'Share.Price' | translate}}  {{total | currency}} (+ taxes)!</p>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="display: flex; justify-content: center;">
            <mat-form-field style="width: 280px;">
              <mat-label>{{'Share.Dish' | translate}}</mat-label>
              <input name="dishName" ngModel matInput>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row style="font-weight: bold;">
          <ion-col style="display: flex; justify-content: center;">
            <ion-label style="text-align: center;">{{ 'Share.Share'| translate }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="display: flex; justify-content: center;">
            <mat-form-field>
              <mat-label>{{'Share.Email' | translate}}</mat-label>
              <input matInput ngModel name="email">
            </mat-form-field>
            <ion-button (click)="shareItem()" style="border-radius: 10px; margin-top: 10px; margin-left: 1px; font-weight: bold;">
              <ion-label style="font-size: 11px;">{{'Share.title' | translate}}</ion-label>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="display: flex; justify-content: center;">
            <ion-label style="font-weight: bold; text-align: center; font-size: 18px;">OR</ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="margin-top: 22px; display: flex; justify-content: center; flex-direction: column; cursor: pointer;">
            <div style="margin: auto; font-weight: bold;">{{'Share.Invite' | translate}}</div>
            <div class="friend-list">
              @if (listToggle) {
                <div class="list unique">
                  @for (img of givenImages; track img) {
                    <div class="friend unique">
                      <div class="check unique" >
                        <mat-checkbox  [id]="img.id" (click)="checkboxEvent($event, img.id, img.selected)"  class="example-margin unique"></mat-checkbox>
                      </div>
                      <div class="profile-pic unique">
                        <img class="pic unique"   [src]="img.img" />
                      </div>
                      <div class="name unique">Jack</div>
                    </div>
                  }
                </div>
              }
              @for (img of selectedImages; track img) {
<img class="friend-pic" style="margin-top: 10px; margin-right: -8px; border: 2px solid white;  height: 30px;
          width: 30px; border-radius: 50%;" [src]="img.img" alt="">
              }
              <div class="friends unique" (click)="toggleList()" id="friend">
                <ion-icon class="unique" style="margin-top: 1px; font-weight: bold; font-size: 24px;" name="add"></ion-icon>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="display: flex; justify-content: center;">
            <ion-button (click)="modalToggle2()" style="width: 200px; font-weight: bold;">
              <ion-label>{{'Share.title' | translate}}</ion-label>
              <ion-icon slot="end" style="color: white;" name="arrow-redo-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-content>
}